import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { inject, observer } from 'mobx-react';
import NavViews from '../../stores/NavViews';
import Countdown from 'react-countdown-now';
import { Icon } from 'antd';
import Color from 'color';
import { utils } from 'web3';

const ethMultiplier = 1000000000000000000;

@observer(["TeamStore", "BetSlipStore", "web3Store", "CustomRouter", "AdminStore", "ViewStore"])
class EventCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teamOneLogo: <Icon style={{ fontSize: '42px', color: '#f72727', padding: '10px' }} type="loading" />,
            teamTwoLogo: <Icon style={{ fontSize: '42px', color: '#1890ff', padding: '10px' }} type="loading" />,//"http://pluspng.com/img-png/nhl-png-datei-logo-nhl-svg-2000.png",
            teamOneName: "",
            teamTwoName: "",
            teamOneAbbreviation: "",
            teamTwoAbbreviation: "",
            loadingTeams: true,
        };
    }

    async componentDidMount() {
        const { TeamStore } = this.props;
        let self = this;
        let team_one = this.props.event.teams[0];
        let team_two = this.props.event.teams[1];

        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (team_one == team._id) {
                    self.setState({
                        teamOneLogo: team.logoUrl,
                        teamOneName: team.name,
                        teamOneAbbreviation: team.abbreviation
                    });
                }
                if (team_two == team._id) {
                    self.setState({
                        teamTwoLogo: team.logoUrl,
                        teamTwoName: team.name,
                        teamTwoAbbreviation: team.abbreviation
                    });
                }
            });
            self.setState({ loadingTeams: false });
            //  console.log("teams: " + JSON.stringify(TeamStore));
        }, 600)



    }

    addToBetSlip(teamChoice) {
        const { BetSlipStore, web3Store } = this.props;
        const {
            bytes32Id,
            startTime,
        } = this.props.event;
        let start_time = startTime;

        let bytes32_id = bytes32Id;

        let team_one = this.props.event.teams[0];
        let team_two = this.props.event.teams[1];

        let selectedTeam = "";
        if (teamChoice == 1) {
            selectedTeam = team_one;
        }
        if (teamChoice == 2) {
            selectedTeam = team_two;
        }
        if (teamChoice == 0) {
            selectedTeam = "Draw";
        }

        const wagerBytes32Id = utils.sha3(selectedTeam + this.props.event._id + teamChoice + (+Date.now()));

        BetSlipStore.WagerList.add({
            bytes32Id: wagerBytes32Id,
            eventId: this.props.event._id,
            eventBytes32Id: bytes32_id,
            maker: web3Store.account,
            value: 50000000000000000,
            odds: 100,
            makerChoice: teamChoice,
            settled: false,
            cancelled: false,
            selectedTeam: selectedTeam,
            team_one: team_one,
            team_two: team_two,
            eventStartTime: start_time,
            isPropWager: false,
            originalEventId: ""
        });
    }

    render() {
        let randNum = Math.floor(Math.random() * Math.floor(20000));
        let otherNum = 20000 - randNum;

        const {
            startTime,
            duration,
            drawPossible,
            betsForTeamOne,
            betsForTeamTwo,
            amountBetForOne,
            amountBetForTwo,
            teamOneColor,
            teamTwoColor,
        } = this.props.event;

        let eventStartTime = new Date();
        eventStartTime.setTime(startTime * 1000);
        let start_time = eventStartTime.toLocaleTimeString() + " - " + eventStartTime.toLocaleDateString();

        let betsForOneDonutData = 0;
        let betsForTwoDonutData = 0;

        if (betsForTeamOne == 0 && betsForTeamTwo == 0) {
            betsForOneDonutData = 1;
            betsForTwoDonutData = 1;
        } else {
            betsForOneDonutData = (amountBetForOne / ethMultiplier).toFixed(2);
            betsForTwoDonutData = (amountBetForTwo / ethMultiplier).toFixed(2);
        }

        const DoughnutData = {
            labels: [
                this.state.teamTwoAbbreviation.toUpperCase(),
                this.state.teamOneAbbreviation.toUpperCase(),
            ],
            datasets: [{
                data: [betsForTwoDonutData, betsForOneDonutData],
                // backgroundColor: [
                //     teamTwoColor,
                //     teamOneColor
                // ],
                // hoverBackgroundColor: [
                //     teamTwoColor,
                //     teamOneColor,
                // ], 
                backgroundColor: [
                    '#5b616b',
                    '#3296f7'

                ],
                hoverBackgroundColor: [
                    '#5b616b',
                    '#3296f7'

                ],
                // backgroundColor: [
                //     this.state.teamTwoColor,
                //     this.state.teamOneColor,
                // ],
                // hoverBackgroundColor: [
                //     this.state.teamTwoColor,
                //     this.state.teamOneColor,
                // ],
                borderColor: [
                    'rgba(255, 255, 255, 0)',
                    'rgba(255, 255, 255, 0)',
                ],
            }]
        };

        let team_one = this.state.teamOneName;
        let team_two = this.state.teamTwoName;



        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;

        let drawButton = "";

        if (drawPossible) {
            drawButton = <button onClick={() => this.addToBetSlip(0)} className="main-page-cards-options-teamtwo">
                <span className="main-page-cards-bet-options-title">DRAW</span>
                {/* <div className="main-page-cards-bets-amount"># OF BETS</div> */}
            </button>
        }

        let cardClassName;

        (this.props.expired ? cardClassName = "main-page-cards-live" : cardClassName = "main-page-cards-open");

        let cardContent = <div>
            <div className="main-page-rows-teams" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>
                <div className="main-page-rows-teams-teamone">
                    <span>{this.state.loadingTeams ? this.state.teamOneLogo : <img src={this.state.teamOneLogo} />}</span>
                    {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                    <div>{team_one}</div>
                </div>
                <div className="main-page-rows-teams-vs">
                    <div style={{ marginTop: '-10px' }}>
                        {!this.state.loadingTeams ? <Doughnut
                            legend={null}
                            width={110}
                            options={{
                                maintainAspectRatio: false
                            }}
                            height={55}
                            data={DoughnutData}
                        /> : <Icon style={{ fontSize: '62px', color: '#5b616b', padding: '10px' }} type="loading" />}
                    </div>
                </div>
                <div className="main-page-rows-teams-teamtwo">
                    <span>{this.state.loadingTeams ? this.state.teamTwoLogo : <img src={this.state.teamTwoLogo} />}</span>
                    <div>{team_two}</div>
                </div>
            </div>
            <div className="main-page-cards-event-info" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>
                <div>{start_time}</div>
            </div>
            
        
            <div className="main-page-cards-status" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>

                {this.props.expired ? <div style={{ padding: '14px 0px 0px 0px', color: '#f73527', textAlign: 'left' }}>
                    <div className="live-icon"></div>
                    <span style={{ display: 'inline-block', marginLeft: '20px' }}>EXPIRED</span>
                </div>
                    : <div className="main-page-cards-status-open-expired">
                        <div style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                            <div className="open-icon"></div>
                            <span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span>
                        </div>
                        <div className="main-page-cards-status-time-remaining">
                            <Countdown zeroPadLength={2} date={new Date(startTime + duration).getTime() * 1000}>
                                <span>ENDED, NO TIME</span>
                            </Countdown>
                            <span style={{ marginLeft: '5px' }}>REMAINING</span>
                        </div>
                    </div>}
            </div>
        </div>


        if (this.props.ViewStore.getGridList == "list") {

            cardContent = <div>
                <div className="main-page-list-style-wrap">
                    <div className="main-page-rows-teams" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>
                        <div className="main-page-rows-teams-teamone">
                            <span>{this.state.loadingTeams ? this.state.teamOneLogo : <img src={this.state.teamOneLogo} />}</span>
                            {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                            <div>{team_one}</div>
                        </div>
                        <div className="main-page-rows-teams-vs">
                            <div style={{ marginTop: '-10px' }}>
                                {!this.state.loadingTeams ? <Doughnut
                                    legend={null}
                                    width={110}
                                    options={{
                                        maintainAspectRatio: false
                                    }}
                                    height={55}
                                    data={DoughnutData}
                                /> : <Icon style={{ fontSize: '62px', color: '#5b616b', padding: '10px' }} type="loading" />}
                            </div>
                        </div>
                        <div className="main-page-rows-teams-teamtwo">
                            <span>{this.state.loadingTeams ? this.state.teamTwoLogo : <img src={this.state.teamTwoLogo} />}</span>
                            <div>{team_two}</div>
                        </div>
                    </div>

                 


                </div>
                <div className="main-page-cards-status" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>

                    {this.props.expired ? <div style={{ padding: '14px 0px 0px 0px', color: '#f73527', textAlign: 'left' }}>
                        <div className="live-icon"></div>
                        <span style={{ display: 'inline-block', marginLeft: '20px' }}>EXPIRED</span>
                    </div>
                        : <div className="main-page-cards-status-open-expired-list">
                            <div style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                <div className="open-icon"></div>
                                <span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span>
                            </div>
                            <div className="main-page-cards-status-info-time">{start_time}</div>
                            <div className="main-page-cards-status-time-remaining">
                                <Countdown zeroPadLength={2} date={new Date(startTime + duration).getTime() * 1000}>
                                    <span>ENDED, NO TIME</span>
                                </Countdown>
                                <span style={{ marginLeft: '5px' }}>REMAINING</span>
                            </div>
                        </div>}
                </div>
            </div>
        }
        return (
            <div className={cardClassName}>
                {cardContent}
            </div>
        );
    }
}

export default EventCards;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/EventCards.js